var _path, _mask, _path2, _path3, _path4, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubMepGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H14V13C14 14.1046 13.1046 15 12 15H4C2.89543 15 2 14.1046 2 13V2Z",
    fill: "#9296AC"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_4620_2432",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.125C0 0.0559644 0.0559644 0 0.125 0H15.8929C15.9619 0 16.0179 0.0559644 16.0179 0.125C16.0179 0.608249 15.6262 1 15.1429 1H0.875001C0.391752 1 0 0.608249 0 0.125Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.125 0V2H15.8929V0V-2H0.125V0ZM15.1429 1V-1H0.875001V1V3H15.1429V1ZM0.875001 1V-1C1.49632 -1 2 -0.496323 2 0.125H0H-2C-2 1.71282 -0.712815 3 0.875001 3V1ZM16.0179 0.125H14.0179C14.0179 -0.49632 14.5216 -1 15.1429 -1V1V3C16.7307 3 18.0179 1.71282 18.0179 0.125H16.0179ZM15.8929 0V2C14.8574 2 14.0179 1.16054 14.0179 0.125H16.0179H18.0179C18.0179 -1.04862 17.0665 -2 15.8929 -2V0ZM0.125 0V-2C-1.04861 -2 -2 -1.04861 -2 0.125H0H2C2 1.16053 1.16053 2 0.125 2V0Z",
    fill: "#9296AC",
    mask: "url(#path-2-inside-1_4620_2432)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 2H13V13C13 13.5523 12.5523 14 12 14H4C3.44772 14 3 13.5523 3 13V2Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11.5C4 11.2239 4.22386 11 4.5 11H11.5C11.7761 11 12 11.2239 12 11.5C12 11.7761 11.7761 12 11.5 12H4.5C4.22386 12 4 11.7761 4 11.5Z",
    fill: "#9296AC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 9,
    width: 8,
    height: 1,
    rx: 0.5,
    fill: "#9296AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubMepGray);
export default __webpack_public_path__ + "static/media/subMepGray.2d1e04182c92137c7fd8207af5785825.svg";
export { ForwardRef as ReactComponent };